import React, { Component } from "react";
import pimg1 from '../../images/partners/logoMinisterio.png' 
import pimg2 from '../../images/partners/logo-2.jpeg' 
import pimg3 from '../../images/partners/logo-3.png' 
import pimg4 from '../../images/partners/logo-4.png'
import pimg5 from '../../images/partners/logo-5.jpeg'
const partners = [
    {
      pImg:pimg1
      
    },
    {
      pImg:pimg2,
    },
    {
      pImg:pimg3,
    },
    {
      pImg:pimg4,
    },
       
    {
      pImg:pimg5,
    },
 
    
]


class PartnerSection extends Component {
    render() {
        return (
            <section className={`partners-section section-padding ${this.props.tNone}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="wpo-section-title">
                                <span>Proyecto</span>
                                <h2>Apoyado por:</h2>
                                <p>El programa nacional de concertación cultural del ministerio de cultura.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-xs-12">
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '40px',
                                padding: '20px 0',
                            }}>
                                {partners.map((partner, pitem) => (
                                    <div key={pitem} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '10px 20px',
                                        background: '#fff',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                        minWidth: '140px',
                                    }}>
                                        <img
                                            src={partner.pImg}
                                            alt=""
                                            style={{
                                                maxHeight: '80px',
                                                maxWidth: '160px',
                                                width: 'auto',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default PartnerSection;